import React from 'react';

const LoadingScreen = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <h2>Loading Application...</h2>
      {/* You can add a spinner/animation here later if you like */}
    </div>
  );
};

export default LoadingScreen;